module.exports = require("wide-align");


//////////////////
// WEBPACK FOOTER
// external "wide-align"
// module id = 9
// module chunks = 0